import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-play-button',
    templateUrl: './play-button.component.html',
    styleUrls: ['./play-button.component.scss'],
    standalone: false
})
export class PlayButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
